import { Typography } from "antd";
import ExecutionStepContainer from "../../containers/LiveCase/ExecutionStepContainer";

const { Paragraph } = Typography;

const NotesPreview = ({ step }) => {
  return (
    <ExecutionStepContainer
      phaseName={step.phase.phaseName}
      label={step.label}
      isCurrentStep={false}
      stepType="Notes"
    >
      {step.description?.split("\n").map((line) => (
        <Paragraph style={{ margin: 0 }}> {line}</Paragraph>
      ))}
    </ExecutionStepContainer>
  );
};
export default NotesPreview;
